const groupingFn = (grouping: any, groupedData: any) => {
  let arr: any = [];
  let group: any = [];
  const tempArr = [];
  if (grouping.includes('.')) {
    group = [grouping.split('.')[0], grouping.split('.')[1]];
  }
  for (let i = 0; i < groupedData?.length; i++) {
    let temp = {};
    if (group.length > 0) {
      temp = {
        _id: groupedData[i]?._id,
        [group[0]]: {
          [group[1]]: `${groupedData[i]?._id} (${groupedData[i]?.count})`,
        },
      };
    } else {
      temp = {
        _id: groupedData[i]?._id,
        [grouping]: `${groupedData[i]?._id} (${groupedData[i]?.count})`,
      };
    }
    tempArr.push(temp);
  }
  arr = tempArr;
  return arr;
};

export default groupingFn;
